import { ChevronDown } from '@prenuvo/halo-icon';
import { Icon } from '@prenuvo/halo-web';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

interface PhoneInputFieldProps {
  value: string | undefined;
  disabled?: boolean;
  onChange: (field: string, value: any) => void;
  error: any;
  placeholder: string;
  name: string;
}

export const ArrowComponent = () => {
  return (
    <Icon
      aria-label="Icon Chevron Down"
      size="sm"
      className="ml-1 fill-neutral-700 dark:fill-neutral-600"
      source={ChevronDown}
    />
  );
};

export const PhoneInputField = ({
  value,
  disabled = false,
  onChange,
  error,
  placeholder,
  name,
}: PhoneInputFieldProps) => {
  return (
    <>
      <PhoneInput
        addInternationalOption={false}
        defaultCountry="US"
        value={value}
        name={name}
        onChange={(value) => onChange(name, value)}
        disabled={disabled}
        autoComplete="tel"
        placeholder={placeholder}
        className={`phoneNumberContainer ${error ? 'phoneNumberErrorBorder' : ''}`}
        limitMaxLength={true}
        countrySelectProps={{
          arrowComponent: ArrowComponent,
        }}
      />
      {error && (
        <span
          id="phoneNumber-caption"
          className="mt-1 pl-4 font-lato text-xs leading-[1.05rem] text-red-500 dark:text-red-400"
          data-testid="halo-caption"
        >
          {error}
        </span>
      )}
    </>
  );
};

export default PhoneInputField;
